export const normalizarEmail = (value = '') =>
  String(value || '').trim().toLowerCase();

export const esEmailValido = (value = '') => {
  const email = normalizarEmail(value);

  if (!email || email.length > 254) {
    return false;
  }

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const obtenerMensajeErrorAuth = (
  error,
  fallback = 'No fue posible completar la operación. Intentá nuevamente.'
) => {
  const message = String(error?.message || error || '').trim();
  const normalized = message.toLowerCase();

  if (!normalized) {
    return fallback;
  }

  if (
    normalized.includes('invalid login credentials') ||
    normalized.includes('invalid credentials')
  ) {
    return 'Email o contraseña incorrectos.';
  }

  if (normalized.includes('email not confirmed')) {
    return 'Tu email todavía no fue confirmado.';
  }

  if (
    normalized.includes('auth session missing') ||
    normalized.includes('session missing') ||
    normalized.includes('invalid refresh token') ||
    normalized.includes('refresh token not found')
  ) {
    return 'La sesión ya no es válida. Volvé a iniciar sesión.';
  }

  if (
    normalized.includes('rate limit') ||
    normalized.includes('too many requests') ||
    normalized.includes('security purposes')
  ) {
    return 'Se realizaron demasiados intentos. Esperá unos minutos y volvé a probar.';
  }

  if (
    normalized.includes('same password') ||
    normalized.includes('different from the old password') ||
    normalized.includes('new password should be different')
  ) {
    return 'La nueva contraseña debe ser diferente de la contraseña actual.';
  }

  if (
    normalized.includes('password should be at least') ||
    normalized.includes('weak password')
  ) {
    return 'La contraseña no cumple los requisitos de seguridad.';
  }

  if (
    normalized.includes('network') ||
    normalized.includes('failed to fetch') ||
    normalized.includes('fetch failed')
  ) {
    return 'No se pudo conectar con el servidor. Revisá tu conexión e intentá nuevamente.';
  }

  return fallback;
};
